import styled from 'styled-components';

export const TrainingFeaturesSection = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(280px, 0.8fr) minmax(0, 1.2fr);
  gap: var(--space-xxxl);

  align-items: flex-start;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }
`;

export const SectionHeading = styled.div`
  max-width: 650px;

  ${({ $center }) =>
    $center &&
    `
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    `}

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.6vw, 3rem);
    line-height: 1.05;
    font-weight: 700;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;

export const FeatureRows = styled.div`
  border-top: 1px solid var(--grey);
`;

export const FeatureRow = styled.div`
  padding: var(--space-xl) 0;

  display: grid;
  grid-template-columns: 55px minmax(0, 1fr);
  gap: var(--space-l);

  border-bottom: 1px solid var(--grey);

  @media screen and (max-width: 500px) {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: var(--space-s);
  }
`;

export const FeatureNumber = styled.span`
  padding-top: 0.15rem;

  color: var(--orange5);

  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
`;

export const FeatureRowContent = styled.div`
  h3 {
    margin: 0 0 var(--space-xs);

    color: var(--grey7);

    font-size: 1.35rem;
    line-height: 1.2;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.92rem;
    line-height: 1.7;
  }
`;
